import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';

interface VehicleData {
  license_plate: string;
  delivered: number;
  returns: number;
  partials: number;
  pending: number;
}

interface VehicleChartProps {
  shipmentsByVehicle: VehicleData[];
}

export default function VehicleChart({ shipmentsByVehicle = [] }: VehicleChartProps) {
  if (!shipmentsByVehicle.length) {
    return (
      <div className="boxIndicator" style={{ flex: '1', minWidth: '0' }}>
        <h3>Envíos por Vehículo</h3>
        <div className="boxIndicatorContent" style={{ padding: '2rem', textAlign: 'center' }}>
          <p>No hay datos disponibles para el período seleccionado</p>
        </div>
      </div>
    );
  }

  // Prepare data for MUI BarChart
  const xAxisData = shipmentsByVehicle.map(vehicle => vehicle.license_plate);
  
  const series = [
    {
      label: 'Entregados',
      data: shipmentsByVehicle.map(vehicle => vehicle.delivered),
      color: '#22c55e', // Green
      stack: 'total',
    },
    {
      label: 'Devueltos', 
      data: shipmentsByVehicle.map(vehicle => vehicle.returns),
      color: '#ef4444', // Red
      stack: 'total',
    },
    {
      label: 'Parciales',
      data: shipmentsByVehicle.map(vehicle => vehicle.partials),
      color: '#f97316', // Orange
      stack: 'total',
    },
    {
      label: 'Pendientes',
      data: shipmentsByVehicle.map(vehicle => vehicle.pending),
      color: '#6b7280', // Gray
      stack: 'total',
    },
  ].filter(serie => serie.data.some(value => value > 0)); // Filter out series with all zero values

  // Calculate dynamic height: 40px per bar
  const desiredBarHeight = 30;
  const numberOfVehicles = shipmentsByVehicle.length;
  const chartHeight = numberOfVehicles * desiredBarHeight + 120; // 120px for margins, legend, and axes
  const containerHeight = chartHeight + 60; // Extra space for container padding

  return (
    <div className="boxIndicator" style={{ flex: '1', minWidth: '0' }}>
      <h3>Envíos por Vehículo</h3>
      <div className="boxIndicatorContent" style={{ height: `${containerHeight}px`, padding: '0.5rem', overflow: 'auto' }}>
        <BarChart
          yAxis={[
            {
              scaleType: 'band',
              data: xAxisData,
            },
          ]}
          xAxis={[
            {
              scaleType: 'linear',
              tickMinStep: 1,
              valueFormatter: (value: number) => Math.round(value).toString(),
            },
          ]}
          series={series}
          layout="horizontal"
          width={undefined}
          height={chartHeight}
          margin={{ left: 80, right: 10, top: 30, bottom: 30 }}
          barLabel="value"
          slotProps={{
            barLabel: {
              style: {
                fill: 'white',
                fontSize: '12px',
                fontWeight: 'bold',
              },
            },
            legend: {
              labelStyle: {
                fontSize: '8px',
              },
              itemMarkWidth: 10,
              itemMarkHeight: 10,
              markGap: 5,
              itemGap: 10,
            },
          }}
        />
      </div>
    </div>
  );
}
